import React, { Component }  from 'react';

class Experience extends Component {
    render() {
        return(
            <main id="xp-page">
            <hr className="featurette-divider" />
                <div className="row featurette">
                    <div className="container marketing col-lg-12">
                        <div className="inner-marketing-row-wrapper row">
                            <div className="col-lg-4">
                                <div className="row gb-purple-box-lg">
                                    <h3>Coding for Web &#38; Applications</h3>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="row">
                                    <span className="gb-blue-box">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <h4>Web Technologies</h4>
                                                <ul>
                                                    <li>PHP (Twig, WordPress)</li>
                                                    <li>MySQL</li>
                                                    <li>JavaScript (jQuery, React, ThreeJS)</li>
                                                    <li>HTML/CSS</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6">
                                                <h4>Languages &#38; Tools</h4>
                                                <ul>
                                                    <li>Java (Maven, JavaFX)</li>
                                                    <li>C# (Unity)</li>
                                                    <li>Python (PyGame)</li>
                                                    <li>C (GBDK - GameBoy games)</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <hr className="featurette-divider" />
    
                <div className="row featurette">
                    <div className="container marketing col-lg-12">
                        <div className="inner-marketing-row-wrapper row">
                            <div className="col-lg-4">
                                <div className="row gb-purple-box-lg">
                                    <h3>Digital Art, 3D Design &#38; Animation</h3>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="row">
                                    <span className="gb-green-box">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <h4>2D Content Creation</h4>
                                                <ul>
                                                    <li>Adobe (Photoshop, Premiere Pro, AfterEffects)</li>
                                                    <li>Various non-Adobe software for similiar tasks.</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6">
                                                <h4>3D Content Creation</h4>
                                                <ul>
                                                    <li>Blender</li>
                                                    <li>Unity</li>
                                                    <li>Maya</li>
                                                    <li>XSI SoftImage</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <hr className="featurette-divider" />
    
                <div className="row featurette">
                    <div className="container marketing col-lg-12">
                        <div className="inner-marketing-row-wrapper row">
                            <div className="col-lg-4">
                                <div className="row gb-purple-box-lg">
                                    <h3>Teaching Instruction &#38; Education</h3>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="row">
                                    <span className="gb-pink-box">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <h4>Instructor XP</h4>
                                                <ul>
                                                    <li>
                                                        <strong>CART Interactive Game Design</strong>
                                                        <br />
                                                        Instruction focuses on Art and Code for game design.
                                                    </li>
                                                    <li><strong>Geekwise HTML/CSS Bootcamp</strong>
                                                        <br />
                                                        Instruction on the fundumentals of HTML and CSS.
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6">
                                                <h4>Education XP</h4>
                                                <ul>
                                                    <li><strong>MS Applied Computer Science</strong><br />University of West Georgia</li>
                                                    <li><strong>BS Sofware Development</strong><br />Bellevue University</li>
                                                    <li><strong>AS Digital Animation</strong><br />Cerro Coso Community College</li>
                                                    <li><strong>CTE Teaching Credential</strong><br />Fresno Pacific University</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

export default Experience;